import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Panel from '../../../../components/angle/Panel/index';
import Spinner from '../../../../components/Spinner';
import { FUND_FILING_TYPE } from '../../../../services/constant/constant';
import {
    setCookie,
    getCookie
} from '../../../../services/helper/cookie-helper';
import { formInputValidation } from '../../../../services/helper/form-helper';

import ClassSearchPanel from './ClassSearchPanel';
import ClassListPanel from './ItemListPanel';
import QuickFilingStatesGrid from './QuickFilingStatesGrid';
import ConfirmDialog from '../../../../components/Dialog/ConfirmDialog';
import FilingRequestForm from '../ClientDetails/components/FilingRequestForm';
import GenericDialog from '../../../../components/Dialog/GenericDialog';

import { fetchAllClientInformationData } from '../../../../services/redux/employee/clientInformation/actions';
import {
    searchClasses,
    clearSearchClassResults,
    clearClassesList,
    fetchClassById
} from '../../../../services/redux/employee/classes/actions';
import {
    fetchPortfolioById,
    fetchPortfolioByTrust
} from '../../../../services/redux/employee/portfolio/actions';
import {
    fetchClassStates,
    updateSecuritySelected,
    updateStateSelected,
    updateSelectedStatesList,
    updateFilingRequestPayload,
    clearFilingsData,
    updateSelectedFilingList,
    submitNewFilingRequest,
    submitNewFilingListRequest,
    fileWithState
} from '../../../../services/redux/employee/filing/actions';

class QuickFilingRequest extends Component {
    constructor(props) {
        super(props);
        this.quickFilingFormRef = React.createRef();
        this.state = {
            showFilingReqModal: false,
            showFilingCheckModal: false,
            checkFilingDialogOptions: {
                header: '',
                content: '',
                buttons: []
            },
            dontShowServiceFeeNotifier: false
        };
    }

    componentDidMount() {
        let { fetchAllClientInformationData, location } = this.props;
        fetchAllClientInformationData(true);

        let dontShowServiceFeeNotifierCookie =
            getCookie('dontShowServiceFeeNotifier') === 'true';

        this.setState({
            dontShowServiceFeeNotifier: dontShowServiceFeeNotifierCookie
        });

        if (!location.from) {
            this.clearComponent();
        }
    }
    clearComponent = () => {
        let {
            clearClassesList,
            clearSearchClassResults,
            clearFilingsData
        } = this.props;
        clearClassesList();
        clearFilingsData();
        clearSearchClassResults();
    };

    onSearchClick = (searchPhrase, clientId) => {
        let {
            searchClasses,
            updateSecuritySelected,
            updateSelectedStatesList
        } = this.props;
        updateSecuritySelected({});
        updateSelectedStatesList([]);
        searchClasses(searchPhrase, clientId);
    };

    onSubmitNewFilingClick = () => {
        let { filing, submitNewFilingRequest } = this.props;
        let payload = {
            clientId: filing.newFiling.clientId,
            [filing.selectedSecurity.typeName]: filing.selectedSecurity.id,
            stateId: filing.selectedState.stateId,
            ...filing.filingRequestData
        };
        if (formInputValidation(this.quickFilingFormRef.current)) {
            submitNewFilingRequest(payload).then(response => {
                if (response.data && response.data.filingStatus === 7) {
                    //FilingStatus(7): ExemptionApproved
                    this.setState({
                        showFilingCheckModal: true,
                        checkFilingDialogOptions: {
                            header: 'Accept Exemption',
                            content: 'This filing can be exempted',
                            buttons: [
                                {
                                    text: 'Apply exemption',
                                    onClick: this.onApplyExemptionClick
                                },
                                {
                                    text: 'File with the state anyway',
                                    onClick: this.onFileWithStateClick
                                }
                            ]
                        },
                        filingId: response.data.filingId
                    });
                } else if (response.data && response.data.filingStatus === 8) {
                    //FilingStatus(8): ExemptionQueried
                    this.setState({
                        showFilingCheckModal: true,
                        checkFilingDialogOptions: {
                            header: 'Exemption not available',
                            content: 'This transaction can not be exempted',
                            buttons: [
                                {
                                    text: 'File with the state anyway',
                                    onClick: this.onFileWithStateClick
                                },
                                {
                                    text: 'OK',
                                    onClick: this.onCancelConfirmationClick
                                }
                            ]
                        },
                        filingId: response.data.filingId
                    });
                } else {
                    this.setState({
                        showFilingReqModal: false,
                        showFilingCheckModal: false,
                        checkFilingDialogOptions: {
                            header: '',
                            content: '',
                            buttons: []
                        }
                    });
                    this.refreshStatesList();
                }
            });
        }
    };

    onFileWithStateClick = () => {
        let { fileWithState } = this.props;
        fileWithState(this.state.filingId).then(response => {
            if (response.status === 200) {
                this.setState({
                    showFilingReqModal: false,
                    showFilingCheckModal: false,
                    checkFilingDialogOptions: {
                        header: '',
                        content: '',
                        buttons: []
                    }
                });
                this.refreshStatesList();
            }
        });
    };

    onCancelFilingReqClick = () => {
        let { updateStateSelected } = this.props;
        updateStateSelected({});
        this.setState({
            showFilingReqModal: false
        });
    };

    onCancelConfirmationClick = () => {
        this.setState({
            showFilingReqModal: false,
            showFilingCheckModal: false,
            checkFilingDialogOptions: {
                header: '',
                content: '',
                buttons: []
            }
        });
        this.refreshStatesList();
    };

    onApplyExemptionClick = () => {
        if (!this.state.dontShowServiceFeeNotifier) {
            this.setState({
                showFilingCheckModal: true,
                checkFilingDialogOptions: {
                    header: 'Accept exemption',
                    content: (
                        <div>
                            <p>
                                A service fee will be applied to your account.
                            </p>
                            <div className="checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        onChange={this.switchServiceFeeNotifier}
                                        style={{ transform: 'scale(1.5)' }}
                                    />
                                    <em> Don't show this message again</em>
                                </label>
                            </div>
                        </div>
                    ),
                    buttons: [
                        {
                            text: 'OK',
                            onClick: this.onCancelConfirmationClick
                        }
                    ]
                }
            });
        } else {
            this.onCancelConfirmationClick();
        }
    };

    onSubmitNewFilingListClick = () => {
        let {
            filing,
            submitNewFilingListRequest,
            updateSelectedStatesList
        } = this.props;
        let selectedStateIds = filing.selectedStates.map(
            state => state.stateId
        );
        let payload = {
            stateIds: selectedStateIds,
            clientId: filing.newFiling.clientId,
            [filing.selectedSecurity.typeName]: filing.selectedSecurity.id
        };

        submitNewFilingListRequest(payload).then(() => {
            this.refreshStatesList();
            updateSelectedStatesList([]);
        });
    };

    switchServiceFeeNotifier = event => {
        const value = event.target.checked;
        setCookie('dontShowServiceFeeNotifier', value, { path: '/' });
        this.setState({
            dontShowServiceFeeNotifier: value
        });
    };

    refreshStatesList = () => {
        let {
            filing,

            fetchClassStates
        } = this.props;

        fetchClassStates(filing.selectedSecurity.id);
    };

    updateStateSelected = selected => {
        let { updateStateSelected } = this.props;
        updateStateSelected(selected);

        if (selected) {
            this.setState({
                showFilingReqModal: true
            });
        } else {
            this.setState({
                showFilingReqModal: false
            });
        }
    };

    updateClassSelected = classId => {
        let {
            updateSecuritySelected,
            updateSelectedStatesList,
            fetchClassStates
        } = this.props;
        updateSelectedStatesList([]);
        let selectedClass = {
            typeName: 'classId',
            typeId: FUND_FILING_TYPE.CLASS,
            id: classId
        };
        updateSecuritySelected(selectedClass);
        fetchClassStates(classId);
    };

    viewEditClass = (classId, mode) => {
        let {
            history,
            fetchClassById,
            fetchPortfolioById,
            fetchPortfolioByTrust
        } = this.props;
        fetchClassById(classId).then(respClass => {
            if (respClass && respClass.portfolioId) {
                fetchPortfolioById(respClass.portfolioId).then(
                    respPortfolio => {
                        if (respPortfolio && respPortfolio.trustId)
                            fetchPortfolioByTrust(respPortfolio.trustId).then(
                                respPortfolios => {
                                    if (
                                        respPortfolios &&
                                        respPortfolios.length > 0
                                    )
                                        if (mode === 'edit')
                                            history.push({
                                                pathname: '/client-details',
                                                from: '/quick-filing-request',
                                                view: 'editClass',
                                                classId: classId
                                            });
                                        else
                                            history.push({
                                                pathname: '/client-details',
                                                from: '/quick-filing-request',
                                                view: 'viewClass',
                                                classId: classId
                                            });
                                }
                            );
                    }
                );
            }
        });
    };

    render() {
        let {
            filing,
            classes,
            user,
            clientInformation,
            updateFilingRequestPayload,
            updateSelectedStatesList
        } = this.props;
        let { checkFilingDialogOptions } = this.state;

        let fileAllButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSubmitNewFilingListClick}
                disabled={filing.selectedStates.length === 0}
            >
                File all selected
            </button>
        );

        let fileAllButtonNote = (
            <h5>
                <em>
                    {' '}
                    These filings will be non-priority and cannot be exempted.
                </em>
            </h5>
        );

        return (
            <div>
                <div className="row">
                    <ClassSearchPanel
                        clientList={clientInformation.clients}
                        onSearchClick={this.onSearchClick}
                        user={user}
                    />
                </div>
                <div className="row">
                    <ClassListPanel
                        itemList={classes.searchClassResults}
                        itemTypeName="classId"
                        onItemClick={this.updateClassSelected}
                        onItemViewEditClick={this.viewEditClass}
                        displayAttributes={[
                            'trustName',
                            'portfolioName',
                            'name',
                            'cusip',
                            'tickerSymbol',
                            'clientCode'
                        ]}
                    />
                </div>
                {filing.selectedSecurity.id && (
                    <div className="row">
                        <div className="col-md-7">
                            <Panel
                                showFooter={true}
                                footerComponents={[
                                    fileAllButton,
                                    fileAllButtonNote
                                ]}
                            >
                                <QuickFilingStatesGrid
                                    dataList={filing.states}
                                    handleButtonClick={this.updateStateSelected}
                                    selectedSecurityType={
                                        filing.selectedSecurity.typeId
                                    }
                                    updateSelected={updateSelectedStatesList}
                                />
                                <ConfirmDialog
                                    header={
                                        'Filing Request - ' +
                                        filing.selectedState.name +
                                        ' - ' +
                                        filing.selectedState.code
                                    }
                                    content={
                                        <div>
                                            <FilingRequestForm
                                                filingRequestData={
                                                    filing.filingRequestData
                                                }
                                                isEditable={true}
                                                updateFileRequestData={
                                                    updateFilingRequestPayload
                                                }
                                                formRef={
                                                    this.quickFilingFormRef
                                                }
                                            />
                                            {filing.fetching && <Spinner />}
                                        </div>
                                    }
                                    confirmButtonText={
                                        filing.filingRequestData
                                            .filingPriorityType === 1
                                            ? 'Check'
                                            : 'File'
                                    }
                                    onConfirm={this.onSubmitNewFilingClick}
                                    onCancel={this.onCancelFilingReqClick}
                                    isShowing={this.state.showFilingReqModal}
                                />
                                <GenericDialog
                                    header={checkFilingDialogOptions.header}
                                    content={
                                        <div>
                                            {checkFilingDialogOptions.content}
                                            {filing.fetching && <Spinner />}
                                        </div>
                                    }
                                    buttons={checkFilingDialogOptions.buttons}
                                    isShowing={this.state.showFilingCheckModal}
                                    showCloseButton={false}
                                />
                            </Panel>
                        </div>
                    </div>
                )}
                {(classes.fetching ||
                    filing.fetching ||
                    clientInformation.fetching) && <Spinner />}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    filing: state.employee.filing,
    classes: state.employee.classes,
    clientInformation: state.employee.clientInformation,
    user: state.authentication.user
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAllClientInformationData,
            fetchClassStates,
            searchClasses,
            clearSearchClassResults,
            clearClassesList,
            updateSecuritySelected,
            updateStateSelected,
            updateSelectedStatesList,
            updateFilingRequestPayload,
            clearFilingsData,
            updateSelectedFilingList,
            submitNewFilingRequest,
            submitNewFilingListRequest,
            fileWithState,
            fetchClassById,
            fetchPortfolioById,
            fetchPortfolioByTrust
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(QuickFilingRequest));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/QuickFilingRequest/index.js